export default __webpack_public_path__ + "static/media/singapore.ac3c538f.png";